import NotificationDropdown from '../components/NotificationDropdown';
import ProfileDropdown from '../components/ProfileDropdown';
import { Link, useLocation } from 'react-router-dom';
import { logout } from '../api/userApi';
import '../Style/TopNav.css';
import api from '../api/client';

function TopNav({ currentUser, setCurrentUser }) {
  const location = useLocation();

  const handleLogout = async () => {
    try {
      // 1. Tell the backend to destroy the session cookie
      await logout();
    } catch (err) {
      // Even if the server is down, we want the user to feel "logged out" locally
      console.error('Logout API call failed, but clearing local session anyway.');
    } finally {
      localStorage.removeItem('X-Auth-Token');
      localStorage.removeItem('notifLastSeen');

      // 2. Remove the token from your API client headers
      // If 'api' is your axios instance:
      delete api.defaults.headers.common['X-Auth-Token'];
      setCurrentUser(null);
      window.location.href = '/login';
    }
  };

  // Helper to check if current path matches link
  const isActive = (path) => location.pathname === path;

  if (!currentUser) return null;

  return (
    <nav className="top-nav">
      <div className="nav-links-container">
        <Link
          to="/ActivityPage"
          className={`nav-link ${isActive('/ActivityPage') ? 'active' : ''}`}
        >
          <span className="nav-icon">🏠</span>
          <span className="nav-label">Home</span>
        </Link>

        <Link to="/" className={`nav-link ${isActive('/') ? 'active' : ''}`}>
          <span className="nav-icon">🎯</span>
          <span className="nav-label">Goals</span>
        </Link>

        <Link to="/leaderboard" className={`nav-link ${isActive('/leaderboard') ? 'active' : ''}`}>
          <span className="nav-icon">🏆</span>
          <span className="nav-label">Ranks</span>
        </Link>

        <Link to="/archived" className={`nav-link ${isActive('/archived') ? 'active' : ''}`}>
          <span className="nav-icon">📦</span>
          <span className="nav-label">Archive</span>
        </Link>
      </div>

      <div className="nav-actions-right">
        <NotificationDropdown />
        <ProfileDropdown user={currentUser} onLogout={handleLogout} />
      </div>
    </nav>
  );
}

export default TopNav;

{
  /* <Link to="/test" className={`nav-link ${isActive('/test') ? 'active' : ''}`}>
          Test
        </Link> */
}
